<loading [isLoading]="isLoading" [success]="!isLoading"></loading>

@if (canView) {
    <div class="flex flex-col gap-4">
        <div class="font-bold pt-2 sm:pt-0 text-ponder-light">
            Alerts
        </div>
        <div class="flex flex-col p-2 bg-slate-100 rounded shadow-md h-full">
            Content
        </div>
    </div>
} @else {
    <admin-unauthorized></admin-unauthorized>
}